import { render, staticRenderFns } from "./proofOfPayment.pug?vue&type=template&id=e8666bd0&scoped=true&lang=pug&"
import script from "./proofOfPayment.ts?vue&type=script&lang=ts&"
export * from "./proofOfPayment.ts?vue&type=script&lang=ts&"
import style0 from "./proofOfPayment.scss?vue&type=style&index=0&id=e8666bd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8666bd0",
  null
  
)

export default component.exports